/**
 * Utility for managing API request headers
 * Automatically includes developer bypass key when admin mode is active
 */

/**
 * Get developer bypass key from localStorage
 * Allows bypassing rate limits when admin mode is activated
 */
export const getDevBypassKey = (): string | null => {
  return localStorage.getItem('devBypassKey');
};

/**
 * Get common headers for API requests
 * Includes developer bypass key if available (for rate limit bypass)
 */
export const getAPIHeaders = (): HeadersInit => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const devKey = getDevBypassKey();
  if (devKey) {
    headers['x-dev-key'] = devKey;
  }

  return headers;
};
